import React from "react";
import {FilterContext, FilterDispatcherContext} from "@providers/filters";

function SearchSorts({className}) {
    const filterDispatcher = React.useContext(FilterDispatcherContext);
    const filters = React.useContext(FilterContext);
    const {sorts} = filters;

    function handleChange(sort) {
        filterDispatcher({
            type: 'SORTS',
            payload: sort
        });
    }

    return (
        <div className="mt-24 mt-lg-56">
            <ul className={'nav nav-tabs ' + (typeof className !== "undefined" ? className : '')}>
                {
                    sorts.map((sort, key) =>
                        <li className={'nav-item mb-0 pb-16 mr-24 ' + (sort.active ? 'active' : '')} key={key} onClick={() => handleChange(sort.name)}>
                            {sort.title}
                        </li>
                    )
                }
            </ul>
        </div>
    )
}

export default SearchSorts;